export default {
    state: {
      villageList: [],
    },
    getters: {
  
    },
    mutations: {
      setvillage(state, val) {
        state.villageList = val
      }
    },
    actions: {}
  
  
  }


// WEBPACK FOOTER //
// ./src/store/modules/village.js